import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';
import { Card } from '../ui/card';
import { Chrome, Settings } from 'lucide-react';

export const SourceConfigCard = ({
  showConfig, onToggleConfig, saveMessage, selectedSources, sources,
  onToggleSource, isLoggedIn, saving, onSavePreferences, onGoogleSignIn, onSaveLocal,
}) => (
  <Card className="p-6 sm:p-8 mb-8">
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center gap-3">
        <Settings className="w-6 h-6 sm:w-8 sm:h-8 text-gray-700" />
        <h2 className="text-xl sm:text-2xl font-serif font-bold">Achieve True Clarity</h2>
      </div>
      <Button onClick={onToggleConfig} variant="outline" size="sm" data-testid="configure-sources-button">
        {showConfig ? 'Hide' : 'Configure'}
      </Button>
    </div>

    {saveMessage && (
      <p className="text-sm font-medium text-green-600 mb-4" data-testid="save-message">{saveMessage}</p>
    )}

    {!showConfig ? (
      <p className="text-sm sm:text-base text-gray-600">
        Tell us which news sources you regularly read, and we will help you discover perspectives you are missing.
        {selectedSources.length > 0 && (
          <span className="block mt-2 font-medium text-blue-600">
            You have configured {selectedSources.length} sources
          </span>
        )}
      </p>
    ) : (
      <div>
        <p className="text-sm sm:text-base text-gray-600 mb-6">
          Select all the news sources and publishers you regularly read or follow on social media.
          We will use this to identify when you are reading outside your bubble.
        </p>

        <div className="mb-4">
          <p className="text-sm text-gray-600">
            {selectedSources.length} of {sources.length} sources selected
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 max-h-96 overflow-y-auto pr-2 mb-6">
          {sources.map((source) => (
            <div
              key={source.id}
              className="flex items-start space-x-3 p-3 border border-gray-200 rounded-lg hover:border-blue-400 hover:bg-blue-50 cursor-pointer transition-colors"
              onClick={() => onToggleSource(source.id)}
              data-testid={`profile-source-${source.id}`}
            >
              <Checkbox
                checked={selectedSources.includes(source.id)}
                onCheckedChange={() => onToggleSource(source.id)}
              />
              <label className="font-medium text-sm cursor-pointer flex-1">
                {source.name}
              </label>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row gap-3">
          {isLoggedIn ? (
            <Button
              onClick={onSavePreferences}
              className="flex-1 flex items-center justify-center gap-2 h-11"
              disabled={selectedSources.length === 0 || saving}
              data-testid="save-preferences-button"
            >
              {saving ? 'Saving...' : 'Save Preferences'}
            </Button>
          ) : (
            <>
              <Button
                onClick={onGoogleSignIn}
                className="flex-1 flex items-center justify-center gap-2 h-11"
                disabled={selectedSources.length === 0}
                data-testid="save-google-signin-button"
              >
                <Chrome className="w-5 h-5" />
                Save & Sign in with Google
              </Button>
              <Button
                variant="outline"
                onClick={onSaveLocal}
                className="flex-1 h-11"
                disabled={selectedSources.length === 0}
                data-testid="save-local-button"
              >
                Save Without Sign In
              </Button>
            </>
          )}
        </div>
      </div>
    )}
  </Card>
);
